<div class="dropdown" ngbDropdown>
  <button class="btn" [ngClass]="buttonClass" type="button" role="button" ngbDropdownToggle>
    {{label}}
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownMenu" (click)="$event.stopPropagation()">
    <div class="dropdown-container">
      <tree  [ngModelOptions]="{standalone: true}" [ngModel]="items"
                    (selectedChange)="onSelectedChange($event)" >
      </tree>
    </div>
  </div>
</div>
<!--
<div class="dropdown" ngxDropdown>
  <button class="btn" [ngClass]="buttonClass" type="button" role="button" ngxDropdownToggle>
    {{selectLabel}}
  </button>
  <div ngxDropdownMenu aria-labelledby="dropdownMenu" (click)="$event.stopPropagation()">
    <div class="dropdown-container">
      <tree  [ngModelOptions]="{standalone: true}" [ngModel]="items"
             (selectedChange)="onSelectedChange($event)" >
      </tree>
    </div>
  </div>
</div>
-->
